<template>
  <img
    class="dashboard-widget-preview"
    :src="previewSrc"
    :style="previewStyle"
    alt=""
    aria-hidden="true"
  />
</template>

<script>
import analyticsPreviewSvg from '@/static/icons/analytics-preview.svg';
import complaintRecordDonutPreviewSvg from '@/static/icons/complaint-record-donut-preview.svg';
import lastSamplesPreviewColorSvg from '@/static/icons/last-samples-preview-color.svg';
import onlineSamplesRegisterCardsPreviewSvg from '@/static/icons/online-samples-register-cards-preview.svg';

const widgetPreviewImageByType = {
  samples: lastSamplesPreviewColorSvg,
  records: onlineSamplesRegisterCardsPreviewSvg,
  complaints: complaintRecordDonutPreviewSvg,
  powerbi: analyticsPreviewSvg,
};

export default {
  name: 'WidgetPreview',
  props: {
    previewType: {
      type: String,
      default: 'generic',
    },
    locked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    previewSrc() {
      return (
        widgetPreviewImageByType[this.previewType] ||
        analyticsPreviewSvg
      );
    },
    previewStyle() {
      return this.locked
        ? {
            opacity: 0.5,
            filter: 'grayscale(0.35)',
          }
        : null;
    },
  },
};
</script>

<style scoped lang="scss">
.dashboard-widget-preview {
  display: block;
  width: 78px;
  min-width: 78px;
  height: 58px;
  object-fit: contain;
  flex: 0 0 78px;
}
</style>
